/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
//   import config from "../../config/activateUser.config.json";
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { RE_ACTIVATE_USER } from '../../api/graphql';
import { vappContainer } from '@/application';
import { notificationConfig } from '../../config/notifications.config';
import { AppNavigatorService } from '@/AppNavigator';
import { Graphql } from '@/common/graphql';
import { apiConfig } from '@/config/apiConfig';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

export interface activateUserProps {
  ids: any;
}

export interface IActivateUserMethods extends IPluginMethodMap {
  activateUser(args: activateUserProps): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export class ActivateUserService implements IAgentPlugin {
  readonly methods: IActivateUserMethods;

  constructor() {
    this.methods = {
      activateUser: this.activateUser.bind(this),
    };
  }

  async activateUser(args: activateUserProps) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    console.log(`args in invite user service`, args);
    try {
      if (client) {
        const res = await client.mutation(RE_ACTIVATE_USER, {
          vuid: args,
        });
        if (res?.data?.reactivateSuspendedUser) {
          return {
            ...res?.data?.reactivateSuspendedUser,
            notification: notificationConfig?.activateUserSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
